



















































































import Component from 'vue-class-component';
import Vue from 'vue';
import GenerateLinksCriteria from './generate-links-criteria.vue';
import * as ent from '@/entities';
import linksApi from '@/api/links.api';
import {saveToCliboard} from '@/utils';
import {mapGetters} from 'vuex';
import * as types from '@/store/types';
import {
    IAgentListItem, ICompany,
    ICriterion,
    IDictionary,
    IFormControl,
    ILinkModel,
    ILinkParamsModel,
    IListItem,
    ISite
} from '@/entities';
import {Watch} from 'vue-property-decorator';
import sitesApi from '@/api/sites.api';
import agentsApi from '@/api/agents.api';
import companiesApi from '@/api/companies.api';

@Component({
    computed: mapGetters({
        superAdminPermissions: types.AUTH_HAS_SUPERADMIN_PERMISSIONS,
        adminPermissions: types.AUTH_HAS_ADMIN_PERMISSIONS,
        companyPermissions: types.AUTH_HAS_COMPANY_PERMISSIONS
    })
})
export default class LinksTranslate extends Vue {
    public adminPermissions: boolean;

    public waitPreload: boolean = true;
    public loading: boolean = false;

    // full lists
    public sites: ISite[] = [];
    public companies: ICompany[] = [];

    // for show
    public site: ISite = null;
    public agent: IAgentListItem = null;


    public linkParts: ILinkParamsModel = null;

    public formState: IDictionary<IFormControl> = {
        linkText: {
            key: 'linkText',
            label: 'Link',
            value: null
        }
    };

    public defaultFormValues(): IDictionary<any> {
        return {
            linkText: null
        };
    }

    public getQueryObject(formState: IDictionary<IFormControl>) {
        return null;
    }

    public async created() {
        try {
            this.loading = true;
            this.sites = await sitesApi.list();
            this.companies = await companiesApi.list();
        } finally {
            this.waitPreload = false;
            this.loading = false;

        }
    }

    @Watch('formState.linkText.value')
    private async onLinkTextChanged(val: string, oldVal: string) {

        const linkRegex = /api\/links\/go\/(\d+)\/(\d+)\/(\d+)/;
        const matches = linkRegex.exec(val);

        if (matches !== null) {
            try {
                this.loading = true;

                this.linkParts = {
                    siteId: parseInt(matches[1], 10),
                    typeId: parseInt(matches[2], 10),
                    agentId: parseInt(matches[3], 10)
                };

                const findSites = this.sites.filter((site) =>
                    site.id === this.linkParts.siteId
                );

                this.site = findSites.length ? findSites.pop() : null;

                const agentsPage = await agentsApi.list({
                    criteria: [
                        {
                            field: 'agents.id',
                            operator: 'AND',
                            value: this.linkParts.agentId
                        }
                    ],
                    page: 1,
                    pageSize: 10,
                    sortAsc: true,
                    sortField: 'username'
                });

                this.agent = agentsPage.items.length ? agentsPage.items.pop() : null;

            } finally {
                this.loading = false;
            }
        } else {
            this.site = this.agent = this.linkParts = null;
        }
    }
}
